import PATH from "constants/path";
import React from "react";
import { Route, Switch } from "react-router-dom";
import Notice from "./pages/Notice";
import NewsComponent from "./pages/News";
import New from "./pages/New";
import PageNotFound from "views/PageNotFound";

function News() {
  return (
    <Switch>
      <Route exact path={PATH.NEWS} component={NewsComponent} />
      <Route exact path={PATH.NOTICE} component={Notice} />
      <Route exact path={PATH.NEW} component={New} />
      <Route component={PageNotFound} />
    </Switch>
  );
}

export default News;
